import { Charity } from "../../../../models/Charity";
import { DrawInfo } from "../../../../models/DrawInfo";
import { USDC } from "../../../../models/UsdcValue";
import Jackpot from "./components/Jackpot";
import RaisingForCharity from "./components/RaisingForCharity";

interface StatusProps {
  /**
   * @description Information about the current draw.
   */
  drawInfo?: DrawInfo;
  /**
   * @description Date of the draw.
   */
  drawDate?: Date;
  /**
   * @description Whether the draw is open (accepting ticket purchases) or not.
   */
  isOpen: boolean;
  /**
   * @description Charity institution.
   */
  charity?: Charity;
  /**
   * @description Whether to show the jackpot or not. True if not specified.
   */
  showJackpot?: boolean;
}

/**
 * @description Status component. Contains the Jackpot and Charity components.
 */
export default function Status(props: StatusProps) {
  const jackpot: number = Number(props.drawInfo?.jackpot?.value ?? 0n);
  return (
    <div className="flex md:flex-row flex-col justify-center pt-[32px] items-center ~space-y-4/6 md:space-y-0 space-x-0 md:~space-x-10/12">
      {(props.showJackpot ?? true) && (
        <Jackpot
          value={new USDC(BigInt(Math.floor(jackpot)))}
          date={props.drawDate}
          isOpen={props.isOpen}
        ></Jackpot>
      )}
      {props.charity != undefined && (
        <RaisingForCharity
          charity={props.charity}
          value={props.drawInfo?.raised}
          goal={props.drawInfo?.charityGoal}
        ></RaisingForCharity>
      )}
    </div>
  );
}
